import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../main/baseQueryWithReauth';
import type {
  CreateLeadMagnetRequest,
  DeleteLeadMagnetRequest,
  GetLeadMagnetsParams,
  GetLeadMagnetsResponse,
  PartnerLeadMagnet,
  UpdateLeadMagnetRequest,
} from './models';

const partnerLeadMagnets = `partner_lead_magnets`;

const leadMagnetsScopeId = (eventId?: number | null) => eventId ?? 'global';

const jsonHeaders = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

export const partnerLeadMagnetsApi = createApi({
  reducerPath: partnerLeadMagnets,
  baseQuery: baseQueryWithReauth,
  tagTypes: [partnerLeadMagnets],
  endpoints: (build) => ({
    getLeadMagnets: build.query<GetLeadMagnetsResponse, GetLeadMagnetsParams>({
      query: ({ event_id }) => ({
        url: '/partner/lead-magnets',
        method: 'GET',
        params: event_id ? { event_id } : undefined,
        headers: { Accept: 'application/json' },
      }),
      providesTags: (_result, _error, { event_id }) => [
        { type: partnerLeadMagnets, id: leadMagnetsScopeId(event_id) },
      ],
    }),
    createLeadMagnet: build.mutation<{ data: PartnerLeadMagnet }, CreateLeadMagnetRequest>({
      query: ({ scope_event_id: _scope, ...body }) => ({
        url: '/partner/lead-magnets',
        method: 'POST',
        body,
        headers: jsonHeaders,
      }),
      invalidatesTags: (_r, _e, { scope_event_id }) => [
        { type: partnerLeadMagnets, id: leadMagnetsScopeId(scope_event_id) },
      ],
    }),
    updateLeadMagnet: build.mutation<{ data: PartnerLeadMagnet }, UpdateLeadMagnetRequest>({
      query: ({ id, scope_event_id: _scope, ...body }) => ({
        url: `/partner/lead-magnets/${id}`,
        method: 'PATCH',
        body,
        headers: jsonHeaders,
      }),
      invalidatesTags: (_r, _e, { scope_event_id }) => [
        { type: partnerLeadMagnets, id: leadMagnetsScopeId(scope_event_id) },
      ],
    }),
    deleteLeadMagnet: build.mutation<{ data: PartnerLeadMagnet }, DeleteLeadMagnetRequest>({
      query: ({ id }) => ({
        url: `/partner/lead-magnets/${id}`,
        method: 'DELETE',
        headers: { Accept: 'application/json' },
      }),
      invalidatesTags: (_r, _e, { scope_event_id }) => [
        { type: partnerLeadMagnets, id: leadMagnetsScopeId(scope_event_id) },
      ],
    }),
  }),
});

export const {
  useGetLeadMagnetsQuery,
  useCreateLeadMagnetMutation,
  useUpdateLeadMagnetMutation,
  useDeleteLeadMagnetMutation,
} = partnerLeadMagnetsApi;
